import styled, {css} from 'styled-components'

export const StyledOverlay = styled.div(
    ({theme: {zIndex}}) => css`
        position: fixed;
        inset: 0;
        background-color: rgb(0 0 0 / 0.1);
        backdrop-filter: blur(12px);
        z-index: ${zIndex.modalOverlay};
    `
)
